export default __webpack_public_path__ + "static/media/z1.41c50feb.jpg";